


export function InstrucoesControloEQualidade() {


    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant) e a secção “Para Controlo” da estante do C&amp;Q;</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados das obras em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Controlo e Qualidade.</div>
            <hr className="mb-5" />
            <div className="mb-2"><span className="font-bold">3.</span> Proceda à confirmação de cotas e tolerâncias pela amostragem já definida, registe as mesmas no formulário
                de controlo e enquadre a conformidade das peças:</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Situar no TopSolid o projeto-cliente e o nº de obra;</div>
                <div className="mb-2"><span className="font-bold">b.</span> Atribuir programa de maquinação;</div>
            </div>
            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  Fase II – Maquinação CNC</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> OK – uma vez validadas seguem para a secção “Peças Controladas” da estante do C&amp;Q</div>
                <div className="mb-2"><span className="font-bold">b.</span> NOK – devem prosseguir para a secção “Peças NOK” e posterior tratamento no M014.</div>
            </div>
            <hr className="mb-5" />
            <div className="mt-10"><span className="font-bold">Notas:</span> Peças sempre acompanhadas da respetiva identificação da obra.</div>
        </div>
    )


}